export class CourseConstants{

    //Routes
    public static readonly Course_CourseDetailScreen: string = '/training/eqms.courses/';
    public static readonly SessionAttendee_QuizAnswers: string = '/training/eqms.quizAnswers/'
    //Spinner Messages
    public static readonly Course_Save_InProgress: string =
    'Save is in progress';

    //Error Messages
    public static readonly Course_Error_Message_Header_Text: string =
    'Please correct the following errors to create the Course.';

     public static readonly Severity_Warning: string = 'warn';
    public static readonly Invalid_Date_Format_Warning: string = 'Date values for few sessions are invalid hence displayed as "Invalid date/time". Please correct them.';

    public static readonly Course_Name_Required: string = 'Name is required';
    public static readonly Course_Status_Required: string = 'Status is required';
    public static readonly Course_Format_Required: string = 'Format is required';
    public static readonly Course_EqmsScope_Required: string = 'eQMS Scope(s) is required';
    public static readonly Course_Description_Required: string = 'Description is required';
    public static readonly Course_Owners_Required: string = 'Owner(s) is required';
    public static readonly Course_ScoringOption_Required: string = 'Scoring Option(s) is required';
    public static readonly Course_QualifiedTrainers_Required: string = 'Qualified Trainer(s) is required';
    public static readonly Course_RecommendedMaxAttendees_Required: string = 'Recommended Max # of Attendees is required';
    public static readonly Course_ProficienyQuiz_Required: string = 'Proficiency Quiz is required';
    public static readonly Course_QualifiedTrainers_Required_CourseIsInstructorLed: string = 'Qualified Trainer is a mandatory field if the Course is Instructor Led';
    public static readonly Course_RecommendedMaxAttendees_Required_CourseIsInstructorLed: string = 'Recommended Max # of Attendees is a mandatory field if the Course is Instructor Led';
    public static readonly Course_MinimumPassingScore_Required_CourseIsInstructorLed: string = 'Minimum Passing Score is required for Minimum Score type Courses';
    public static readonly Course_ValidityPeriodInterval_Required_ValidityRangeIsEntered : string ='A time unit (days, months or years) must be defined for the Validity Period'
    public static readonly Course_ValidityPeriod_must_Be_Greater_Than_Zero:string= 'Validity Period must be greater than 0.';

    public static readonly Course_CourseNotFound_ErrorMessage: string ='This Course does not exist.';
    public static readonly LinkText:string = "Access to the Training Material here";
    public static readonly Course_SelfStudy_With_PassFail_Validation: string = "Proficiency Quizzes are not allowed for Self-Study Courses with a Pass/Fail scoring option.";
  public static readonly Course_SelfStudy_With_MinScore_Validation: string = "Automated Proficiency Quiz is mandatory for Self-Study Courses with a Minimum Score scoring option.";
  public static readonly Course_RoleAcessPermission_Fail: string = "Unable to fetch Roles permission";
  public static readonly Course_Created_Failed : string = 'Due to some technical issue, the course was not created. Please try again.';

  // confirmation Messages
    public static readonly Course_Slider_Confirmation_Header: string =
    'Confirmation';
    public static readonly Course_Slider_Confirmation_Text: string =
    'Any unsaved change will be lost when closing the screen. Do you want to continue?';

    public static readonly Course_Created_Success: string =
    'Course Created Successfully';
    public static readonly Course_Updated_Success: string =
    'Course Updated Successfully';
    public static readonly Session_Created_Success: string =
    'Session Created Successfully';
    public static readonly Session_Updated_Success: string =
    'Session Updated Successfully';

    public static readonly Cancel_Session_Confirmation_Header: string =
    'Confirmation';
    public static readonly Cancel_Session_Confirmation_Text: string =
    'You are about to Cancel a Session. This action is not reversible. Do you want to proceed?';

    public static readonly Enroll_Session_Confirm_Text: string = 
    'You are about to enroll in this Session. Do you want to proceed?';
    public static readonly Withdrawal_Session_Confirm_Text: string =
    'You are about to withdraw from this Session. Do you want to proceed?';
    public static readonly Session_Enrollment_Confirmation_Header: string =
    'Confirmation';
    public static readonly Session_Wwithdraw_Confirmation_Header: string =
    'Confirmation';
    public static readonly Enrollment_Session_Confirmation_Header: string =
    'You have Successfully Enrolled in the session';    
    public static readonly Enrollment_Session_validation_Message: string =
    'You dont have the prerequisite training to take this Course. You must complete or at least enroll in the prerequisite first. NOTE: This prerequisite must be completed before taking the subsequent course.';
    public static readonly Withdrawal_Session_Success_Header: string =
    'You have Withdrawn from the session';
    public static readonly Session_Attendee_Confirmation_Header: string =
    'Confirmation';
    public static readonly Session_Attendee_Confirmation_Text: string =
    'Any unsaved change will be lost when closing the screen. Do you want to continue?';

    public static readonly Session_AttendeeUpdate_Confirmation_header: string = 
    'Confirmation';
    public static readonly Session_AttendeeUpdate_Confirmation_Text: string = 
    'I acknowledge that the trainee(s) has/have completed the instructor-led Training Course and have been assigned a grade accordingly. If passed, the training for this Course will be marked as Complete and the Training Plan will be updated accordingly. If failed, the training for this Course will remain Pending.';
    public static readonly Session_AttendeeUpdate_Sucess_Heade: string =
    'You have Successfully Updated session Attendees';
    public static readonly Session_AttendeePassOrFailUpdate_Error: string =
      'The following attendees have not been updated because their Participation status is not appropriate:';
    public static readonly Session_Attendee_ProficiencyQuiz_None: string = 'None';
    public static readonly Session_Attendee_ScoringOption_PassFail: string = 'Pass/Fail';
    public static readonly Deleted_Attachments_Confirmation_Message: string =
    'You are about to delete the following attachments. This action is not reversible. Do you want to proceed?'
    
    public static readonly Session_Attendee_PassAttendeeValidation : string =
    'The following Attendees have not been updated because they are already in Passed status';
    

    public static readonly Session_Cancelled_Success: string =
    'Session Cancelled Successfully';
    public static readonly Enroll_Users_Error_message: string = 'Only users with a Pending Training for the Course were enrolled in this Session. Other selected users have not been enrolled-[0] '
    public static readonly Attendee_Failure_Error_Message : string = 'Failed to update attendees. Please try again.'
    public static readonly Severity_Success: string = 'success';
    public static readonly Severity_Info: string = 'info';
    public static readonly Severity_Error: string = 'error';
    public static readonly Course_Status_Inactive:string= 'Inactive';

    public static readonly ValidityPeriod_InformationToolTip: string = "How long until each certificate holder will need to retake the course?"
    public static readonly TopBarTitle_CourseCatalogue: string ='Course Catalogue';
    public static readonly CourseFormControls_Disabled_ByDefault = ['qualifiedTrainers','owners','minimumPassingScore','validityPeriodInterval','recommendedMaxAttendees','estimatedDuration'];
    public static readonly CourseFormControls_QualifiedTrainers = ['qualifiedTrainers'];
    public static readonly CourseFormControls_Owners = ['owners'];
    public static readonly CourseFormControls_MinimumPassingScore = ['minimumPassingScore'];
    public static readonly CourseFormControls_EstimatedDuration = ['estimatedDuration'];
    public static readonly CourseFormControls_RecommededMaxAttendees = ['recommendedMaxAttendees'];
    public static readonly CourseFormControls_ValidityPeriodInterval = ['validityPeriodInterval'];

    public static readonly RelatedDocuments_Not_Aligned_With_Scope_ConfirmationMessage: string =
    `This Related Document is associated 
    with a different eQMS Scope than the current course. Users may not be able to view this Related 
    Document based on their particular eQMS Scope access. Do you wish to continue and link the Related Document?`;


    public static readonly AssignmentGroup_QualifiedTrainerAssignment : number = 7;
    public static readonly AssignmentGroup_CourseOwnerAssignment : number = 9;

    //Title bar 
    public static readonly Course_CourseDetailsTopBarTitle :string = "Course Details";
    public static readonly Course_CourseInfoHeader :string = "Course Info";
    public static readonly Course_CourseSummaryHeader :string = "Course Summary";
    public static readonly Course_CourseDetailsHeader :string = "Details";
    public static readonly Course_CourseScoringHeader :string = "Scoring";
    public static readonly Course_CoursePrerequisitesHeader :string = "Prerequisite(s)";
    public static readonly Course_CourseEquivalentCoursesHeader :string = "Equivalent Course(s)";


  //Session related constants
    public static readonly SessionFormControls_Room = ['room'];
    public static readonly SessionFormControls_VirtualMeetingURL = ['virtualMeetingURL'];
    public static readonly session_Format_InPerson_Value= 0;
    public static readonly Session_Format_Virtual_Value=1;
    public static readonly Session_Format_Eiter_Value=2;
    public static readonly Session_Format_Ether_text= "Either"
    public static readonly Session_Enrollment_Open= 0;
    public static readonly Session_Attendee_ShowAllInformation : string = "Show All";
    public static readonly Session_Attendee_InformationToolTip: string= "By default attendees with Participation = Withdrawn are not displayed. Check this check box to display them.";

    public static readonly course_Format_InstructorLed_Value= "Instructor Led";
    public static readonly course_Format_SelfStudy_Value= "Self Study";
   

  //Attachments max limits
  public static readonly Attachment_File_Max_Size: number = 100;
  public static readonly Attachments_File_Max_Limit: number = 1;

  //Session error messages
  public static readonly Session_StartDateTime_Required: string = 'Session start date time is required';
  public static readonly Session_EndDateTime_Required: string = 'Session end date time is required';
  public static readonly Session_Time_Zone_Required: string = 'Time zone is required';
  public static readonly Session_Format_Required: string = 'Format is required';
  public static readonly Session_Room_Required: string = 'Room field is required';
  public static readonly Session_Enrollment_Required: string = 'Enrollment field is required';
  public static readonly Session_VirtualMeetingURL_Required: string = 'Virtual meeting URL is required';
  public static readonly Session_StartTimeShouldBe: string = 'The Session Start Time must be before End Time';
  public static readonly Session_TainersCannotBeNull: string = 'You must define an Internal or Other Trainer for the Course';
  public static readonly Session_Status_Scheduled: string = "Scheduled"
  public static readonly Show_All_Session_Info: string = "By default only Sessions in Scheduled Status are displayed. Check this check box to display all the Sessions, regardless of their Status.";
  public static readonly Virtual_MeetingURL_Text: string = "Virtual Meeting URL";
  public static readonly Session_Slider_Heder_Text: string = "Add Session"; 
  public static readonly Session_Slider_Heder_Text_For_Edit: string = "Edit Session"; 
  public static readonly Session_Attendee_Slider_Header_Text: string = "Session Attendees";
  public static readonly Session_Attendee_WaitlistParticipationUpdate_Confirmation: string = 
    "There is a wait list of attendees for this Session. Do you want to replace the Withdrawn attendee(s) by Waitlist attendee(s)? This will be by 'first come-first served basis', meaning the earliest Waitlist attendees will be enrolled in the session first.";

  public static readonly Session_Error_Message_Header_Text: string =
    'Please correct the following errors to add the session to the course.';
    public static readonly Trainers_Field_Constant: string ="trainers"

    public static readonly SessionAttachmentFolderName = "eqmsdocumenttemplates";


    public static readonly AssignmentGroupType:number = 0;

    public static readonly Course_Create_General_Tab_Index: number = 0;
    public static readonly Course_Create_Training_Material_Tab_Index: number = 2;
    public static readonly Course_Prerequisites_Index: number = 1;
    
    public static readonly Course_Details_Session_Tab_Index = 1;
    public static readonly Course_Details_Training_Tab_SelfStudy_Index: number = 2;
    public static readonly Course_Details_Training_Tab_InstructorLed_Index: number = 3;
    

    //Proficiency Quiz Slider
    public static readonly Course_Proficiency_Quiz_Title: string = 'Proficiency Quiz';
    public static readonly Course_Proficiency_Quiz_ErrorText: string = 'Please correct the following errors.';
    public static readonly CourseProficiencyQuiz_Slider_Confirmation_Header: string = 'Confirmation';
    public static readonly CourseProficiencyQuiz_Slider_Confirmation_Text: string = 'Any unsaved change will be lost when closing the screen. Do you want to continue?';
    public static readonly Course_Proficiency_Quiz_Min_Passing_Score_Required : string = "Minimum Passing Score is required"
    public static readonly Course_Proficiency_Quiz_Section_Required : string = "Quiz Section is required"
    public static readonly Course_Proficiency_Quiz_Saved_Success: string = 'Course Proficiency Quiz Saved Successfully';
    public static readonly Severity_Err: string = 'error';
    public static readonly Course_Proficieny_Quiz_Save_Progress: string = 'Course Proficiency Quiz Save is in progress';
    public static readonly Course_Proficieny_Quiz_Uodate_Progress: string = 'Course Proficiency Quiz Update is in progress';
    public static readonly Course_Proficieny_Quiz_Details_Loading: string = 'Course Proficiency Quiz is loading';
    public static readonly ProficiencyQuiz_ResultPass: string ='Pass';
    public static readonly ProficiencyQuiz_ResultFail: string ='Fail';
    public static readonly ProficiencyQuiz_UpdateFailed: string = 'A technical error occurred and your Quiz result was not recorded in your training plan. Please retry and if this error persists, report it to your support contact.';
    public static readonly TrainingPlan_UpdateFailed: string = 'A technical error occurred and your training was not recorded in your training plan. Please retry and if this error persists, report it to your support contact.';

    //Training tab
    public static readonly CourseTraining_UpdatedSuccessfully : string = "Training Plan has been updated successfully."
    public static readonly CourseTraining_ConfirmationMessage_WithNoQuiz: string = "I acknowledge that I have completed and understood this Self-Study Course. The training for this Course will be marked as Complete and the Training Plan will be updated accordingly.";
    public static readonly CourseTraining_ButtonLabel_WithNoQuiz: string = "I Have Completed Training on this Course";
    public static readonly CourseTraining_ButtonLabel_WithQuiz: string = "Take Proficiency Quiz";
    public static readonly CourseTraining_ConfirmationMessage_WithSelfStudyQuiz: string = "I acknowledge that answers to this Proficiency Quiz are completed after taking this self-study Training Course. The training for this Course will be marked as Complete only with a passing score within the maximum number of allowed attempts (Attempts), and the Training Plan will be updated accordingly.";
    public static readonly CourseTraining_ConfirmationMessage_WithInstructorLedQuiz: string = "I acknowledge that answers to this Proficiency Quiz are completed after attending the instructor-led Training Course. The training for this Course will be marked as Complete only with a passing score within the maximum number of allowed attempts (Attempts) , and the Training Plan will be updated accordingly."

    public static readonly CourseTraining_CourseProficiencyQuiz_None: number = 0;
    public static readonly CourseTraining_CourseProficiencyQuiz_eQMSAutomatedGrading: number = 1;
    public static readonly CourseTraining_CourseProficiencyQuiz_eQMSTrainerGrading: number = 2;
    public static readonly CourseTraining_CourseProficiencyQuiz_PaperQuiz: number = 3;

    public static readonly CourseTraining_MaximumAttempts_Unlimited : string = "Unlimited";
    public static readonly CourseTraining_Complete_Validation : string = "You don't have the prerequisite training to take this Course. You must complete the prerequisite training first.";
    public static readonly CourseApi_Error_Message : string = "An unexpected error occurred, Please contact Admin."

    //Prerequisite
    public static readonly Course_Prerequisite_DeletePrerequisiteMessage : string = "You are about to delete a prerequisite. Do you wish to confirm?"
    public static readonly Course_Prerequisite_DocumentLinkedMultipleTimes : string = 
    "The Document(s) DocumentNumbers is already a Prerequisite Document, it is not possible to add it again."
    public static readonly Course_Prerequisite_CourseLinkedMultipleTimes : string = 
    "The Course(s) CourseNumbers is already a Prerequisite Course, it is not possible to add it again."
    public static readonly Course_Prerequisite_CourseHasNoEqmsScopeInCommon : string = 
    "This Prerequisite Course  - CourseNumber is associated with a different eQMS Scope than the Course. " + 
    "Users may not be able to view this Prerequisite Course based on their particular eQMS Scope access. "+
    "Do you wish to continue and link the Prerequisite Course?"
    public static readonly Course_Prerequisite_DoumentHasNoEqmsScopeInCommon : string = 
    "This Prerequisite Document - DocumentNumber is associated with a different eQMS Scope than the Course. " + 
    "Users may not be able to view this Prerequisite Document based on their particular eQMS Scope access. "+
    "Do you wish to continue and link the Prerequisite Document?"
    public static readonly Course_PrerequisiteType_Document : number = 1;
    public static readonly Course_PrerequisiteType_Course : number = 2;


  public static readonly File_Upload_Failed : string = 'A Technical error occurred and the Name was not uploaded. Please contact technical support.'
  public static readonly CourseTrainingMaterials : string = 'Course Training Material Attachment(s)'
  public static readonly SessionAttachments : string = 'Session Attachment(s)'

  public static readonly QuizTaking_Title: string = 'Take Proficiency Quiz';
  public static readonly QuizTaking_Description: string = 'Press Esc to cancel the quiz and close this window.';


  public static readonly Complete_Date_Required: string = 'Complete Date is a mandatory field.';

  public static readonly CoursePrerequisitesTab : string = 'Course Prerequisites'
  public static readonly CourseTrainingMaterialTab : string = 'Course Training Materials'
  public static readonly CourseLibraryScreen : string = 'Course Library'
  public static readonly Show_All_Sessions_Label: string = 'Show All';

  
  public static readonly Course_Prerequisites_Document_Tab_Index = 0;
  public static readonly Course_Prerequisites_Course_Tab_Index = 1;


}
